module.exports = __webpack_public_path__ + "static/img/__1001.76ffe7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1001.jpg
// module id = z0Eh
// module chunks = 0